import { render, staticRenderFns } from "./New.vue?vue&type=template&id=6d92c6a4&scoped=true&"
import script from "./New.vue?vue&type=script&lang=js&"
export * from "./New.vue?vue&type=script&lang=js&"
import style0 from "./New.vue?vue&type=style&index=0&id=6d92c6a4&lang=scss&scoped=true&"
import style1 from "./New.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d92c6a4",
  null
  
)

export default component.exports